/**
 * Sound registry mapping logical sound IDs to file paths
 * Organizes all audio assets by category (ambience, music, sfx)
 */

export const SOUND_REGISTRY = {
  // ===== DICE SOUNDS (SFX) =====
  d6_roll: {
    category: 'sfx',
    variations: [
      '/audio/d6/01',
      '/audio/d6/02',
      '/audio/d6/03',
      '/audio/d6/04',
      '/audio/d6/05',
      '/audio/d6/06',
      '/audio/d6/07'
    ]
  },
  d20_roll: {
    category: 'sfx',
    variations: [
      '/audio/d20/01',
      '/audio/d20/02',
      '/audio/d20/03',
      '/audio/d20/04',
      '/audio/d20/05'
    ]
  },

  // ===== UI SOUNDS (SFX) =====
  ui_confirm: {
    category: 'sfx',
    path: '/audio/ui/ui_wood_confirm'
  },
  ui_back: {
    category: 'sfx',
    path: '/audio/ui/ui_wood_back'
  },
  ui_open: {
    category: 'sfx',
    path: '/audio/ui/ui_wood_open'
  },
  ui_close: {
    category: 'sfx',
    path: '/audio/ui/ui_wood_close'
  },
  ui_error: {
    category: 'sfx',
    path: '/audio/ui/ui_wood_error'
  },
  ui_notice: {
    category: 'sfx',
    path: '/audio/ui/notice'
  },
  ui_warning: {
    category: 'sfx',
    path: '/audio/ui/warning'
  },
  ui_chime: {
    category: 'sfx',
    path: '/audio/ui/ui_belltree_up_01'
  },
  ui_positive: {
    category: 'sfx',
    variations: [
      '/audio/ui/technical/positive/01',
      '/audio/ui/technical/positive/02',
      '/audio/ui/technical/positive/03',
      '/audio/ui/technical/positive/04'
    ]
  },
  ui_negative: {
    category: 'sfx',
    variations: [
      '/audio/ui/technical/negative/01',
      '/audio/ui/technical/negative/02',
      '/audio/ui/technical/negative/03',
      '/audio/ui/technical/negative/04'
    ]
  },

  // ===== MUSIC (Music category) =====
  music_victory: {
    category: 'music',
    path: '/audio/ui/music_positive'
  },
  music_defeat: {
    category: 'music',
    path: '/audio/ui/music_negative'
  },
  music_jingle_positive: {
    category: 'music',
    path: '/audio/ui/high_pitch_jingle'
  },
  music_jingle_negative: {
    category: 'music',
    path: '/audio/ui/negative_jingle_music'
  },

  // ===== TASK SOUNDS (SFX) =====
  task_build: {
    category: 'sfx',
    path: '/audio/tasks/build'
  },
  task_chop: {
    category: 'sfx',
    path: '/audio/tasks/chop'
  },
  task_gather: {
    category: 'sfx',
    path: '/audio/tasks/gather'
  },
  task_knowledge: {
    category: 'sfx',
    path: '/audio/tasks/knowledge'
  },

  // ===== EVENT SOUNDS (SFX) =====
  event_traveler: {
    category: 'sfx',
    path: '/audio/events/horse'
  },

  // ===== WEATHER SOUNDS (Ambience category) =====
  weather_rain: {
    category: 'ambience',
    path: '/audio/weather/rain',
    loop: true
  },
  weather_storm: {
    category: 'ambience',
    path: '/audio/weather/thunderstorm'
  },

  // ===== COMBAT SOUNDS (SFX) =====
  combat_warcry: {
    category: 'sfx',
    path: '/audio/voices/warcry'
  },

  // ===== SEASONAL AMBIENCE (Ambience category - looping) =====
  ambience_spring: {
    category: 'ambience',
    path: '/audio/ambience/spring',
    loop: true
  },
  ambience_summer: {
    category: 'ambience',
    path: '/audio/ambience/summer',
    loop: true
  },
  ambience_fall: {
    category: 'ambience',
    path: '/audio/ambience/fall',
    loop: true
  },
  ambience_winter: {
    category: 'ambience',
    path: '/audio/ambience/winter',
    loop: true
  }
};

/**
 * Get all sound IDs by category
 */
export function getSoundsByCategory(category) {
  return Object.entries(SOUND_REGISTRY)
    .filter(([, config]) => config.category === category)
    .map(([id]) => id);
}

/**
 * Check if a sound ID exists in the registry
 */
export function isValidSoundId(soundId) {
  return soundId in SOUND_REGISTRY;
}
